import { render, staticRenderFns } from "./MsgElementRevoke.vue?vue&type=template&id=1ce5de91&scoped=true"
import script from "./MsgElementRevoke.vue?vue&type=script&lang=js"
export * from "./MsgElementRevoke.vue?vue&type=script&lang=js"
import style0 from "./MsgElementRevoke.vue?vue&type=style&index=0&id=1ce5de91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5de91",
  null
  
)

export default component.exports